import React, { Fragment, useState } from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { CreateGroupModal } from "../modals/CreateGroupModal";
import { ACL } from '../../../../../../../config/constants';
import { store } from '../../../../../../../store/store';
import { hideNotification } from '../../../../../../../store/actions/notification';

const CreateGroup = (props) => {

  const [ showModal, setShowModal ] = useState( false );

  if (! ACL.ADMIN.GROUPS.CREATE.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Button
        className="btn-warning"
        color="primary"
        size="sm"
        onClick={() =>{
          store.dispatch(hideNotification());
          setShowModal( true )
        }}
      >
        <FormattedMessage
          id="components.pages.admin.users.buttons.create_group"/>
      </Button>
      <CreateGroupModal
        actionCallback={props.actionCallback}
        showModal={showModal}
        closeModal={() => setShowModal( false )}
      />
    </Fragment>
  )
}

export { CreateGroup };

